import { getFetch, postFetch, putFetch, deleteFetch } from '../utils/fetch';
import {
  FACILITYENVIPROTECTFEE_API,
  FACILITYENVIPROTECTFEE_EXPORT_API,
  FACILITYENVIPROTECTFEE_GETALL_API,
  FACILITYENVIPROTECTFEE_EXPORT_WITH_IDS_API
} from './config';

export function getList(query) {
  return getFetch(`${FACILITYENVIPROTECTFEE_API()}`, query);
}

export function getOne(_id) {
  return getFetch(`${FACILITYENVIPROTECTFEE_API()}/${_id}`);
}

export function updateOne(_id, data = {}) {
  return putFetch(`${FACILITYENVIPROTECTFEE_API()}/${_id}`, data);
}

export function deleteOne(_id) {
  return deleteFetch(`${FACILITYENVIPROTECTFEE_API()}/${_id}`);
}

export function create(obj) {
  return postFetch(`${FACILITYENVIPROTECTFEE_API()}`, obj);
}

export function exportData(query) {
  return getFetch(`${FACILITYENVIPROTECTFEE_EXPORT_API()}`, {
    ...query
  });

}

export function getAll() {
  return getFetch(`${FACILITYENVIPROTECTFEE_GETALL_API()}`);
}


export function exportDataWithIds(query) {
  return postFetch(`${FACILITYENVIPROTECTFEE_EXPORT_WITH_IDS_API()}`, {
    ...query,
  });
}


// WEBPACK FOOTER //
// ./src/api/facilityEnviProtectFeeApi.js